module.exports = __webpack_public_path__ + "static/media/RadiusAllsidesblack.923fc5c9.svg";